export default __webpack_public_path__ + "static/media/arrow-blue.c666ddc9.svg";